<template>
	<div v-if="dialogVisible" class="dialog-mask">
		<div class="login-box">
			<div class="title_box">
				<img src="@/assets/logo.png" alt="Logo" class="logo-image" />
				<h1 style="margin:0px">锦田云</h1>
				<h2>智控全球云端</h2>
			</div>
			<div style="padding: 30px;">
				<el-tabs v-model="loginMethod" stretch>
					<!-- 账号密码登录 -->
					<el-tab-pane label="账号密码登录" name="password">
						<el-input v-model="username" placeholder="请输入账号" class="input" />
						<el-input v-model="password" type="password" placeholder="请输入密码" class="input" show-password />
						<el-button type="primary" size="large" class="login-button" @click="handleLogin">登录</el-button>
					</el-tab-pane>
					<!-- 手机验证码登录 -->
					<el-tab-pane label="验证码登录" name="phone">
						<el-input v-model="phone" placeholder="请输入手机号" class="input" @input="handlePhoneInput" />
						<div style="display: flex; gap: 10px;">
							<el-input v-model="code" placeholder="验证码" class="input" style="flex: 1" type="password"
								show-password />
							<el-button :disabled="codeTimer > 0" @click="sendCode" :loading="sendingCode">
								{{ codeTimer > 0 ? codeTimer + 's' : '发送验证码' }}
							</el-button>
						</div>
						<el-button type="primary" size="large" class="login-button" @click="handleLogin">登录</el-button>
					</el-tab-pane>
				</el-tabs>
				<div class="agreement-view">
					<div class="flex_between_center">
						<el-checkbox v-model="agreement_checked" />
						<div>我已阅读并同意<span @click="skip_agreement('UserAgreement')">《用户协议》</span>和<span
								@click="skip_agreement('PrivacyPolicy')">《隐私政策》</span></div>
					</div>
					<el-link type="primary" @click="$router.push('/register')">注册账号</el-link>
				</div>
				<div class="Kefu-icon-view" @click="kefuDialogVisible = true">
					<el-icon>
						<Service />
					</el-icon>
					<span style="margin-left: 4px;">联系客服</span>
				</div>
			</div>
			<div class="browser-position">浏览器推荐:<img width="20" height="20" src="../assets/google_logo.jpg"> google浏览器<span style="color: #1886f3;">120.0.6099.63</span>以上</div>
		</div>
	</div>
	<Kefu_dialog v-model:Kefu_dialog_flag="kefuDialogVisible" @close="kefuDialogVisible=false" />
</template>
<script>
	import md5 from 'js-md5';
	import Kefu_dialog from '../components/Kefu_dialog'
	import request from '@/utils'
	export default {
		name: 'Login_dialog',
		components: {
			Kefu_dialog
		},
		props: {
			"dialogVisible": { //接收父组件传参控制弹框是否显示
				type: Boolean,
				default: false //默认为false不显示登录框
			},
		},
		data() {
			return {
				kefuDialogVisible: false, //客服弹窗开关
				agreement_checked: false, //协议勾选
				loginMethod: 'password',
				username: '',
				password: '',
				phone: '',
				code: '',
				codeTimer: 0,
				timer: null,
				sendingCode: false, // 新增发送验证码加载状态
			};
		},
		methods: {
			handlePhoneInput(event) {
				this.phone = event.replace(/[^\d]/g, '');// 过滤掉所有非数字字符
			},
			async handleLogin() {
				if (!this.agreement_checked) {
					this.$message.error('请您勾选协议后再登录');
					return;
				}
				this.loading = true;
				try {
					let params = {
						login_type: this.loginMethod
					};
					if (this.loginMethod === 'password') {
						// 密码登录
						if (!this.username || !this.password) {
							this.$message.error('请输入账号和密码');
							return;
						}
						params.password = md5(this.password); // MD5加密
						params.username = this.username; // 假设用户名就是手机号
					} else {
						// 验证码登录
						if (!this.phone || !this.code) {
							this.$message.error('请输入手机号和验证码');
							return;
						}
						params.phone = this.phone;
						params.code = this.code;
					}
					const response = await request.post('/login/login', params, {
						customHandle: true
					})
					if (response.data.code === 200) {
						this.$message.success('登录成功');
						// 保存token到本地
						localStorage.setItem('token', response.data.data.token);
						localStorage.setItem('userID', response.data.data.userID);
						this.$store.commit('Update_Local_keyboard_flag', true)
						var userdata = {
							username: this.username
						}
						// // 设置axios全局请求头
						// axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`;
						// this.$router.push('/Purches/default-id-123');
						this.$emit('update:dialogVisible', false)
						this.$store.commit('isLogin_fun')
						window.location.reload()
					} else {
						this.$message.error(response.msg || '登录失败');
					}
				} catch (error) {
					this.$message.error('登录失败，请稍后重试');
				} finally {
					this.loading = false;
				}
			},
			async sendCode() {
				if (!this.phone) {
					this.$message.error('请输入手机号');
					return;
				}
				// 简单的手机号格式验证
				if (!/^1[3-9]\d{9}$/.test(this.phone)) {
					this.$message.error('请输入正确的手机号');
					return;
				}
				this.sendingCode = true;
				try {
					const response = await request.post(`/login/send_message`, {
						phone: this.phone
					}, {
						customHandle: true
					});
					if (response.data.code === 200) { // 假设成功返回code为200
						this.$message.success('验证码发送成功');
						this.startCodeTimer();
					} else {
						this.$message.error(response.data.data.message || '验证码发送失败');
					}
				} catch (error) {
					this.$message.error('验证码发送失败，请稍后重试');
				} finally {
					this.sendingCode = false;
				}
			},
			startCodeTimer() {
				this.codeTimer = 60;
				this.timer = setInterval(() => {
					this.codeTimer--;
					if (this.codeTimer === 0) {
						clearInterval(this.timer);
					}
				}, 1000);
			},
			skip_agreement(type) {
				window.open(`http://www.hnjintian.com/agreement/${type}.html`, '_blank');
			}
		},
		beforeUnmount() {
			if (this.timer) clearInterval(this.timer);
		},
	};
</script>

<style lang="less" scoped>
	/* 遮罩层样式 */
	.dialog-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.3s ease;
	}

	/* 对话框容器 */
	.dialog-container {
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
		animation: dialog-fade-in 0.3s;
	}
	.browser-position{
		position: absolute;
		left: 10px;
		bottom: 10px;
		display: flex;
		align-items: center;
	}
	.agreement-view {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 50px;
		div {
			margin-left: 10px;
		}

		span {
			color: #1886f3;
			cursor: pointer;
		}
	}

	:deep(.el-checkbox__inner) {
		padding: 4px;
		border-radius: 10px;
	}

	/* 对话框动画 */
	/* 	@keyframes dialog-fade-in {
	  0% {
	    transform: translateY(-20px);
	    opacity: 0;
	  }
	  100% {
	    transform: translateY(0);
	    opacity: 1;
	  }
	} */
	.login-box {
		width: 500px;
		background: white;
		border-radius: 20px;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
		text-align: center;
		overflow: hidden;
		position: relative;
		.title_box {
			padding-top: 20px;
			background: url('@/assets/title-bg-DNMSieOB.png')no-repeat;
			background-size: 100% 100%;

			h2 {
				font-weight: 500;
				color: #59637f;
			}
		}
	}

	.logo-image {
		width: 100px;
		margin-bottom: 16px;
	}

	.input {
		margin-bottom: 12px;
		width: 100%;
	}

	.login-button {
		width: 100%;
	}

	.Kefu-icon-view {
		width: 100%;
		margin-top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #1886f3;
		cursor: pointer;
		position: absolute;
		bottom: 40px;
		left: 0;
		right: 0;
	}
</style>